import type {ElementType} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './title.module.css';

type Props = {
  /** @default h2 */
  readonly as?: ElementType;
};

export function CompanyInformationTitle({as: As = 'h2'}: Props) {
  return (
    <As
      className={clsx(
        styles.title,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      会社概要
    </As>
  );
}
